const PREFIX = "/external_basket/";
export const SUBSCRIBE_EXTERNAL_BASKETS_URL = PREFIX + "subscribe";
export const ADD_EXTERNAL_BASKET_TO_USER_BASKET_URL = PREFIX + "add_to_user";
